var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-bg"},[_vm._v("\n    我的\n    "),_c('work-nav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }